export default class DateControl {
  constructor (element, args) {
    let div = document.createElement('div')
    this.input = document.createElement('input')
    this.input.id = window.PRIM.getUUID()
    this.setValue(args.value)
    this.input.type = 'date'
    this.input.placeholder = 'jjjj-mm-dd'
    this.input.pattern = '\d{4}(-\d{2}(-\d{2}?)?)?'
    this.input.disabled = args.readonly ? 'disabled' : ''    
    this.input.onchange = args.onchange
    this.label = document.createElement('label')
    this.label.innerHTML = args.label
    this.label.htmlFor = this.input.id

    let fragment = document.createDocumentFragment()
    fragment.appendChild(div)
    div.appendChild(this.label)
    div.appendChild(this.input)

    element.appendChild(fragment)
  }

  setLabel (text) {
    this.label.innerHTML = text
  }

  getValue () {
    return this.input.value ? new Date(this.input.value) : null
  }

  setValue (value) {
    this.input.value = value ? window.PRIM.getUtcTimestamp(new Date(value)).toISOString().substring(0, 10) : ''
  }
}


// WEBPACK FOOTER //
// ./js/lib/ui/DateControl.js